import { render, staticRenderFns } from "./HotelBookingModal.vue?vue&type=template&id=2b047052"
import script from "./HotelBookingModal.vue?vue&type=script&lang=js"
export * from "./HotelBookingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports